import Alert from '../../components/ui/Alert';
import { useCheckoutContext } from '../../context/checkout.context';
import { useAddressForm } from '../../hooks/address-form.hook';
import { testId } from '../../utils';
import { CheckoutAddress } from './checkout-address';
import { useTranslation } from '@rpi/i18n';
import React from 'react';

export const ShippingAddress: React.FC = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.checkout' });
  const { setShippingAddress, checkoutIsLoading, errors } =
    useCheckoutContext();
  const addShippingAddressForm = useAddressForm();
  const editShippingAddressForm = useAddressForm();

  return (
    <div className="flex flex-col gap-4 pt-4">
      {errors.shippingAddress && (
        <Alert {...testId('shipping-options', 'error')} variant="error">
          {t('shipping_address_error')}
        </Alert>
      )}
      <CheckoutAddress
        {...testId('shipping-address')}
        onContinue={setShippingAddress}
        addAddressForm={addShippingAddressForm}
        editAddressForm={editShippingAddressForm}
        checkoutLoading={checkoutIsLoading}
      />
    </div>
  );
};
